(ns hypnos.consumer.panels.portrait.not-found)

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn step
  "Error message when the step could not be found."
  []
  [:div "Page not found!"])
